module.exports = __webpack_public_path__ + "static/media/adjuge-pt.a947f7b3.png";